/**
 * Feature-local constants for the Monetics application form.
 * Mark/brand identifiers live in the shared `MONETIC_MARKS` (src/constants).
 * Values here are reproduced verbatim from the previous inline literals — do not
 * change them without checking the add/edit payload contract.
 */

// --- Port / timeout / serial defaults set when switching mark or resetting ---
export const DEFAULT_MONETIC_PORT = "8888";
export const VALINA_DEFAULT_PORT = "";
export const YAVIN_DEFAULT_PORT = 5000;
export const DEFAULT_MONETIC_TIMEOUT = "120";
export const YAVIN_DEFAULT_SERIAL_NUMBER = 5000;

// --- Reference defaults applied on mark change ---
// NOTE: the default ("EXAMPLE 1") and the Valina dropdown options ("EXEMPLE 1")
// differ in spelling in the original code; both are kept as-is intentionally.
export const VALINA_DEFAULT_REFERENCE = "EXAMPLE 1";
export const NEPTING_DEFAULT_REFERENCE = "S300";

// --- Reference dropdown options ---
export const VALINA_REFERENCE_OPTIONS = [
    "EXEMPLE 1",
    "EXEMPLE 2",
    "EXEMPLE 3",
    "EXEMPLE 4",
];
export const NEPTING_REFERENCE_OPTIONS = ["S300", "IM 20", "IM 30", "Q25", "A35"];

// --- Communication modes (Valina / Yavin / Adyen) ---
export const COMMUNICATION_LOCAL = "Local";
export const COMMUNICATION_CLOUD = "Cloud";
export const COMMUNICATION_OPTIONS = [
    { label: COMMUNICATION_LOCAL, value: COMMUNICATION_LOCAL },
    { label: COMMUNICATION_CLOUD, value: COMMUNICATION_CLOUD },
];

// --- Adyen / Yavin environment mode ---
export const MONETIC_MODE_PRODUCTION = "Production";
export const MONETIC_MODE_TEST = "Test";

// --- Nepting terminal-type codes ---
export const TERMINAL_TYPE_KIOSK = "25"; // Automate kiosk (Pre-authorization)
export const TERMINAL_TYPE_POS = "22"; // TPE POS (Debit)

// --- Nepting setup-type (config) options ---
export const SETUP_TYPE_OTHER = "Autre";
export const SETUP_TYPE_OPTIONS = [
    "ERT 10",
    "ERT 45",
    "ERT 46",
    SETUP_TYPE_OTHER,
];

// --- Valina payment-method codes ---
export const PAYMENT_METHOD_TPE_CONFIG = "1";
export const PAYMENT_METHOD_ENABLED = "3";
export const PAYMENT_METHOD_DISABLED = "4";

// --- Adyen IP-derived port/webhook bases + autofill UI delay ---
export const ADYEN_PORT_BASE = 5000;
export const ADYEN_WEBHOOK_BASE = 9000;
export const ADYEN_AUTOFILL_DISABLE_DELAY_MS = 3000;

// --- Toast auto-close durations (ms) ---
export const TOAST_AUTOCLOSE_MS = 2000;
export const TOAST_AUTOCLOSE_LONG_MS = 5000;
